/**
 * Case-insensitive substring search over name, GlobalId and every property
 * value. Several words are ANDed. Bounded result list; `total` is the full match count.
 */
import type { IfcElement, IfcIndex } from './index';

export const SEARCH_LIMIT = 200;

export type SearchResult = { total: number; elements: IfcElement[] };

export function searchElements(index: IfcIndex, query: string, limit = SEARCH_LIMIT): SearchResult {
	const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
	if (terms.length === 0) return { total: 0, elements: [] };
	const elements: IfcElement[] = [];
	let total = 0;
	for (const element of index.elements) {
		if (element.placeholder) continue;
		if (!terms.every((term) => element.haystack.includes(term))) continue;
		total += 1;
		if (elements.length < limit) elements.push(element);
	}
	return { total, elements };
}
